//
// BodyController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "../../models/view/Body";
import "./MediaContainerController";
import "./VisualController";

var BodyController = createModule("BIRD::BodyController", ["BIRD::BIRDModelController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getAllVisualControllers: [[1]],
        getModel: [1],
        getMediaContainerController: [1],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default BodyController;
